import { Box, Tabs, Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { hasPermission } from 'store'

export const tabConfig = [
  {
    index: 0,
    label: "Health Conditions",
    path: "health-conditions",
    permission: 'nurse.health',
  },
  {
    index: 1,
    label: "Visits",
    path: "visits",
    permission: 'nurse.visit',
  },
  {
    index: 2,
    label: "Health Report",
    path: "health-report",
    permission: 'nurse.health',
  },
  {
    index: 3,
    label: "Visit Report",
    path: "visit-report",
    permission: 'nurse.visit',
  },
]

export default function NurseTabs() {
  const basePath = `/health`
  const theme = useSelector(state => state.session.appearance)
  const { t } = useTranslation()
  const { '*': tabName } = useParams()
  const permittedTabs = tabConfig.filter(tab => hasPermission(tab.permission));

  const getTabIndex = path => {
    const [tabName] = path.split("/");
    const found = permittedTabs.find(tab => tab.path === tabName);
    return found ? found.index : permittedTabs[0]?.index ?? 0;
  };
  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName));
  }, [tabName, permittedTabs.length]);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        <Tabs value={tabIndex}>
          {permittedTabs.map(tab => (
            <Tab
              key={tab.path}
              sx={{ color: tabIndex === tab.index && "primary !important" }}
              className={tabIndex === tab.index
                ? `tab-item-selected`
                : `tab-item-${theme}`
              }
              label={t(tab.label)}
              value={tab.index}
              component={Link}
              to={`${basePath}/${tab.path}`}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}
